import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { catchError } from 'rxjs/operators';
import { SearchFilters } from '../dashboard/search-panel/search-panel.model';
import { BudgetPerformanceWidgetVM, CostPerWidgetVM, InspectionCuntWidgetVM } from './get-widgets.model';
@Injectable()
export class GetWidgetsService {

  constructor(private _http: HttpClient) { }


public GetBudgetPerformanceAgainstBudget(params: SearchFilters): Observable<BudgetPerformanceWidgetVM> {
  return this._http.post<BudgetPerformanceWidgetVM>("Api/GETDashboard/GetBudgetPerformanceAgainstBudget", params).pipe(catchError(this.handleError));
}

public GetCostPerHourWidgetData(params: SearchFilters): Observable<CostPerWidgetVM> {
  return this._http.post<CostPerWidgetVM>("Api/GETDashboard/GetCostPerHourWidgetData", params).pipe(catchError(this.handleError));
}

public GetCostPerBCMWidgetData(params: SearchFilters): Observable<CostPerWidgetVM> {
  return this._http.post<CostPerWidgetVM>("Api/GETDashboard/GetCostPerBCMWidgetData", params).pipe(catchError(this.handleError));
}

public GetCostPerTonWidgetData(params: SearchFilters): Observable<CostPerWidgetVM> {
  return this._http.post<CostPerWidgetVM>("Api/GETDashboard/GetCostPerTonWidgetData", params).pipe(catchError(this.handleError));
}

public GetInspectionCarriedOut(params: SearchFilters): Observable<InspectionCuntWidgetVM> {
  return this._http.post<InspectionCuntWidgetVM>("Api/GETDashboard/GetInspectionCarriedOut", params).pipe(catchError(this.handleError));
}

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
}
